export default function () {
  if (document.getElementById('guided-search-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "guided-search-app" */ '../_03_organisms/guided-search/main');
  }
}
